(function ($) {
  function scrollToElement(el) {
    var $target = $(el);
    var scrollMargin = parseInt($target.css('scrollMarginTop'), 10) || 0;
    var targetY =
      scrollMargin > 0
        ? $target.offset().top - scrollMargin
        : $target.offset().top - ($('.header').outerHeight(true) || 0);
    var startY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var distance = targetY - startY;

    if (Math.abs(distance) < 1) {
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.scrollTo(0, targetY);
      return;
    }

    var duration = 500;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) {
        startTime = timestamp;
      }

      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 0.5 - Math.cos(progress * Math.PI) / 2;
      window.scrollTo(0, startY + distance * eased);

      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    }

    window.requestAnimationFrame(step);
  }

  $(document).on('click', '.content_post .p-toc__link', function (e) {
    var targetId = this.getAttribute('data-toc-target');
    if (!targetId) {
      return;
    }

    var el = document.getElementById(targetId);
    if (!el) {
      return;
    }

    e.preventDefault();
    scrollToElement(el);

    if (history.replaceState) {
      window.setTimeout(function () {
        history.replaceState(null, '', '#' + targetId);
      }, 520);
    }
  });

  $(document).on('click', '.p-toc__expandBtn', function () {
    var $button = $(this);
    var $toc = $button.closest('.p-toc');
    var expanded = !$toc.hasClass('is-expanded');

    if (expanded) {
      $toc.removeClass('is-omitted').addClass('is-expanded');
      $button.attr('aria-expanded', 'true');
      $button.text('折りたたむ');
    } else {
      $toc.addClass('is-omitted').removeClass('is-expanded');
      $button.attr('aria-expanded', 'false');
      $button.text('もっと見る');
    }
  });
})(jQuery);
